export const STANDARD_MENU_ID = "standard";

export interface SharedMenuDefinition {
  id: string;
  name: string;
  navigation: Record<string, unknown>[];
}

export interface MenuSite {
  menus?: SharedMenuDefinition[];
  layout?: { header?: Record<string, unknown>; [key: string]: unknown };
}

export function sharedMenus(site: MenuSite): SharedMenuDefinition[] {
  return Array.isArray(site.menus)
    ? site.menus.filter(
        (menu) =>
          menu &&
          typeof menu.id === "string" &&
          menu.id !== STANDARD_MENU_ID &&
          typeof menu.name === "string" &&
          Array.isArray(menu.navigation),
      )
    : [];
}

/** Standard reads the existing website menu; a named empty menu deliberately stays empty. */
export function applySharedMenu<T extends Record<string, unknown>>(
  site: MenuSite,
  config: T,
  menuId: unknown,
): T {
  if (typeof menuId !== "string") return config;
  const menu = sharedMenus(site).find((entry) => entry.id === menuId);
  const root = site.layout?.header ?? {};
  const result: Record<string, unknown> = {
    ...config,
    menuId: menu?.id ?? STANDARD_MENU_ID,
  };
  delete result.navigation;
  const classic = config.classic;
  if (classic && typeof classic === "object" && !Array.isArray(classic)) {
    result.classic = { ...classic };
    delete (result.classic as Record<string, unknown>).navigation;
  }
  if (menu) result.navigation = menu.navigation;
  else if (Array.isArray(root.navigation)) result.navigation = root.navigation;
  else if (
    root.classic &&
    typeof root.classic === "object" &&
    !Array.isArray(root.classic)
  ) {
    const navigation = (root.classic as Record<string, unknown>).navigation;
    if (Array.isArray(navigation))
      result.classic = {
        ...(result.classic as Record<string, unknown>),
        navigation,
      };
  }
  return result as T;
}
